import Translator    from 'bazinga-translator';
import jstz          from 'jstz';
import {events}      from "../../commun/backbone/decorators";
import Routing       from "../app/router";
import LoginBaseView from "./login-base-view";

@events({
            'click .btn-connexion': '_onClickButton',
            'click #reset-password' : '_onClickResetPassword',
            'click #reset-password-extranet' : '_onClickResetPasswordExtranet',
            'input input#login-username, input#login-password' : '_onInputChange',
            'change input#login-username, input#login-password' : '_onInputChange',
            'click ul#action-link-form-group a' : '_onClickLink',

        })
/**
 * @property {LoginModel} model
 */
class LoginView extends LoginBaseView
{
    initialize(options)
    {
        super.initialize(options);

        this.timeoutid = null;
        this.listenTo(this.model, 'load-language', (language) => this._onLoadLanguage(language))
    }

    render()
    {
        super.render();

        this.$username = $('#login-username');
        this.$btnconnexion = $('#btn-connexion');

        this.$timezone = $('#login-timezone');

        if (this.$timezone.length){
            const hasSelected = this.$timezone.has('[selected]').length > 0;
            if (!hasSelected)
            {
                const timezone = jstz.determine();
                this.$timezone.val(timezone.name());
            }
        }
    }

    _onInputChange(event)
    {
        //console.log('_onInputChange', event.type, event.target);
        this._resetAlertMessage();
    }

    _onClickButton(event)
    {
        this._resetAlertMessage();

        let $target = $(event.target);
        if (!$target.is('a') && !$target.is('button')){
            $target = $target.parent();
        }

        if (!$target.is('#sso-openidconnect')) {
            const login = this.$username.val();
            if (!login.length) {
                this._setAlertMessage(Translator.trans('login.need_login', {}, 'js'));
                event.preventDefault();
                return;
            }
        }

        $target.addClass('active');
    }

    _onClickResetPassword(event)
    {
        event.preventDefault();

        this._resetAlertMessage();

        const login = this.$username.val();
        if (!login.length) {
            this._setAlertMessage(Translator.trans('login.need_login', {}, 'js'));
        }
        else {
            if (confirm(Translator.trans('reset_password.confirm', {}, 'js')))
            {
                const that = this;
                this.model.resetPassword(login)
                 .then(function (data)
                       {
                           that._setInfoMessage(data.message);
                       })
                 .catch(function (jqx)
                       {
                           const data = jqx.responseJSON;
                           if (Array.isArray(data) && data.length){
                               const error = data.shift();
                               that._setAlertMessage(error.message);
                           }
                           else if(data.hasOwnProperty('message')){
                               that._setAlertMessage(data.message);
                           }
                       });
            }
        }
    }

    _onClickResetPasswordExtranet(event)
    {
        event.preventDefault();

        window.location = Routing.generate('session_reset_password_extranet', {login: this.$username.val(), _locale: this.$locale.val()})
    }

    _onClickLink(event)
    {
        event.preventDefault();
        const $a = $(event.target);
        const url = $a.data('url');
        const idaction = $a.data('action');
        if (!_.isEmpty(url)){
            window.location = `${url}?ID=${idaction}`;
            return ;
        }

        this._resetAlertMessage();

        $a.addClass('active');
        this.model.executeAction(idaction).then((data) => {
            if (data.message.length){
                this._setInfoMessage(data.message);
            }
        }).catch((err) => {
            this._setAlertMessage(err.responseJSON.message);
        }).finally(()=>{
            $a.removeClass('active');
        });
    }

}
export default LoginView;